import axios, { AxiosRequestConfig } from "axios";

const instance = axios.create();
instance.interceptors.response.use((response) => {
  return response.data;
});
export function request<T = any>(url: string, options?: AxiosRequestConfig) {
  return instance(url, options) as Promise<T>;
}
